import {
  StyleSheet, Text, TouchableOpacity, View
} from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import FeatherIcon from "react-native-vector-icons/Feather";
import GetCardType from "../helpers/creditCard";
import * as Colors from "../styles/colors";
import * as Fonts from "../styles/typography";
import PayIcon from "./PayIcon";

export default function CardItem({
  cardBrand,
  cardNumber,
  checked,
  style,
  text,
  onPressCard,
  onPressDelete,
  hasSelect = true,
  iconName = "",
  iconColor = "",
  iconType = "materialcommunity",
  iconSize = 32,
  textStyle = {},
}) {
  return (
    <TouchableOpacity style={[styles.radioCard, style]} onPress={onPressCard}>
      {hasSelect ? (
        <View style={[styles.checkView, { borderColor: iconColor }]}>
          {checked ? <View style={styles.checkedView} /> : null}
        </View>
      ) : (
        <></>
      )}

      {iconName ? (
        iconType == "feather" ?
          <FeatherIcon name={iconName}
            size={iconSize}
            color={iconColor}
            style={{ marginHorizontal: 8 }} />
          : <Icon name={iconName}
            size={iconSize}
            color={iconColor}
            style={{ marginHorizontal: 8 }} />)
        : <PayIcon
          item={
            cardBrand ? cardBrand : cardNumber ? GetCardType(cardNumber) : "generic"
          }
          showHint={false}
        />}
      {cardNumber ? (
        <Text style={styles.cardInfoText}>
          {" "}
          Final {cardNumber.substring(12, 16)}
        </Text>
      ) : null}
      {text ? <Text adjustsFontSizeToFit={true} numberOfLines={1} style={[styles.cardInfoText, textStyle]}>{text}</Text> : null}
      <TouchableOpacity style={{ marginLeft: "auto" }} onPress={onPressDelete}>
        {cardNumber ? <Icon name={"trash-can-outline"} size={24} /> : null}
      </TouchableOpacity>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  radioCard: {
    // borderColor: Colors.BLACK,
    // borderWidth: 1,
    borderRadius: 8,
    flexDirection: "row",
    alignItems: "center",
    marginTop: 8,
    padding: 4,
    backgroundColor: Colors.SNOW,
    borderColor: Colors.SECONDARY,
    borderLeftWidth: 2,
    shadowColor: Colors.GRAY_DARK,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    borderRadius: 8,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  radioCardChecked: {
    borderColor: Colors.WARNING,
    borderWidth: 1,
    borderRadius: 8,
    marginBottom: 16,
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: Colors.BLACK,
  },
  cardInfoText: {
    fontSize: Fonts.FONT_SIZE_18,
    marginLeft: 4,
  },
  cardInfoTextChecked: {
    fontSize: Fonts.FONT_SIZE_18,
    color: Colors.WHITE,
    fontWeight: "bold",
  },
  iconColor: {
    color: Colors.EHITE,
  },
  iconColorChecked: {
    color: Colors.CHIP,
  },
  checkView: {
    borderWidth: 1,
    width: 16,
    height: 16,
    borderRadius: 8,
    // position: "absolute",
    padding: 2,
    // right: 4,
    margin: 8,
    alignItems: "center",
    justifyContent: "center",
  },
  checkedView: {
    flex: 1,
    flexGrow: 1,
    width: "100%",
    borderRadius: 8,
    backgroundColor: Colors.INFO,
  },
});
